import { Component, computed, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { HlmButton } from '@spartan-ng/helm/button';
import { HlmPopoverImports } from '@spartan-ng/helm/popover';
import { HeaderComponent } from '../../atoms/header/header.component';
import { OpenInBrowserButtonComponent } from '../../atoms/open-in-browser-button/open-in-browser-button.component';
import { BreadcrumbComponent } from '../../molecules/breadcrumb/breadcrumb.component';
import { AvatarComponent } from '../../molecules/avatar/avatar.component';
import { ThemeSelectorComponent } from '../../molecules/theme-selector/theme-selector.component';
import {
  AuthorizationStrategy,
  RequestLogoutMessage,
  ROUTE,
  UrlFlagsService,
  UserStrategy,
} from 'shared';

@Component({
  selector: 'ocp-embedded-layout',
  imports: [
    HeaderComponent,
    BreadcrumbComponent,
    AvatarComponent,
    OpenInBrowserButtonComponent,
    ThemeSelectorComponent,
    TranslatePipe,
    HlmPopoverImports,
    HlmButton,
    RouterLink,
  ],
  templateUrl: './embedded-layout.component.html',
  styleUrl: './embedded-layout.component.scss',
})
export class EmbeddedLayoutComponent {
  private readonly authorizationService = inject(AuthorizationStrategy);
  private readonly urlFlagsService = inject(UrlFlagsService);
  private readonly userFacade = inject(UserStrategy);

  readonly userInitials = this.userFacade.initials;
  readonly userEmail = computed(() => this.userFacade.user()?.email ?? '');
  readonly showLogout = this.urlFlagsService.showLogout;
  readonly tocRoute = ['/', ROUTE.toc];
  readonly imprintUrl = `/${ROUTE.imprint}`;

  onLogoutClick(): void {
    if (this.urlFlagsService.embedded()) {
      RequestLogoutMessage.send();
    } else {
      this.authorizationService.logout().subscribe();
    }
  }

  onOpenInBrowser(): void {
    const currentUrl = new URL(globalThis.location.href);
    currentUrl.searchParams.set('embedded', '0');
    globalThis.open(currentUrl.toString(), '_blank', 'noopener');
  }
}
